import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { v4 as uuidv4 } from "uuid";

axios.defaults.headers.common["AgencyID"] = window.configData.AGENCYID;
axios.defaults.headers.common["Version"] = import.meta.env.VITE_APP_VERSION;
axios.defaults.headers.common["App"] = window.configData.APP;

const createCardsSlice = (sliceName) => {
  const initialState = { cards: [] };

  const reducers = {
    addOffers: (state, action) => {
      console.log(action.payload);
      let tempCards = [...state.cards];

      if (action.payload.payload.thunk === "searchHotelOffers") {
        if (action.payload.payload.offset === 0) tempCards = [];

        const existingIds = new Set(tempCards.map((e) => e.currentOfferId));

        for (let offer of action.payload.offers) {
          if (existingIds.has(offer.OfferID)) continue;

          tempCards.push({
            id: uuidv4(),
            currentOfferId: offer.OfferID,
            originalOfferId: offer.OfferID,
            moreAlternativeFlights: true,
            alternativeFlights: [],
            moreBetterOffers: true,
            betterOffers: [],
          });

          existingIds.add(offer.OfferID);
        }
      }

      if (action.payload.payload.thunk === "searchAlternativeTransports") {
        /*let tempCard = tempCards.find((e)=>e.originalOfferId == )



        if (action.payload.payload.offset === 0) tempCards = [];

        const existingIds = new Set(tempCards.map((e) => e.currentOfferId));

       

          existingIds.add(offer.OfferID);
        }*/
      }

      state.cards = tempCards;
    },
    clearCards: (state) => {
      state.cards = [];
    },
  };

  if (sliceName == "cross") {
    reducers.addCards = (state, action) => {
      state.cards = [...state.cards, action.payload];
    };
  }

  return createSlice({
    name: sliceName,
    initialState,
    reducers,
  });
};

export const crossSlice = createCardsSlice("cross");
export const { addOffers, clearCards, setCards } = crossSlice.actions;

export const classicSlice = createCardsSlice("classic");
export const { clearCards: clearClassicCards, addOffers: addClassicOffers } =
  classicSlice.actions;

export const configurationReducers = {
  cross: crossSlice.reducer,
  classic: classicSlice.reducer,
};
